import type { DocPageContent } from '../docs-content'

const page = {
  order: 8,
  slug: 'preview',
  title: '预览与播放',
  description: '播放控制、逐帧步进、缩放、代理播放和监听音频。',
  category: '核心编辑',
  sections: [
    {
      title: '播放控制',
      items: [
        '通过预览控件或空格键播放和暂停。',
        '逐帧前进后退，进行逐帧精确检查。',
        '跳转到时间线的开头或结尾。',
        '使用时间码进行精确位置检查。',
      ],
    },
    {
      title: '预览视图',
      items: [
        '调整预览缩放而不改变导出画布。',
        '在审查运动或构图时使用全屏。',
        '在需要时将当前帧保存为图像。',
        '编辑选中项目时使用变换、蒙版和编辑叠加层。',
      ],
    },
    {
      title: '播放性能',
      items: [
        '当存在代理时，对大体积源媒体使用代理播放。',
        '监视器/设备音量仅影响本地播放。',
        '导出使用项目混音，而不是监听音量设置。',
      ],
    },
  ],
} satisfies DocPageContent

export default page